import { useState } from "react";
import { StandardButton } from "../atoms/buttons";
import { icon } from "../functions/icons";
import { countries, NLPROVINCES } from "../constants/countries";
import { HorizontalLayout } from "../components/layout";
import { DropdownRows } from "../components/countryDropdownComp";

export function CountryDropdown({className = "",setCountrys}) {
  const [openProvince, setOpenProvince] = useState(false);
  const [openCountry, setOpenCountry] = useState(false);
  const [defaultCountry, setDefaultCountry] = useState({ code: false, name: false });
  const [country, setCountry] = useState({ code : defaultCountry.code || "nl", land : defaultCountry?.name || "Netherlands", visible: true , province: null});
  const [province, setProvince] = useState({"flag": "https://upload.wikimedia.org/wikipedia/commons/a/a2/North_Brabant-Flag.svg", "name": "North Brabant"});
  const toggleProvince = () => openCountry ? (setOpenCountry(false), setOpenProvince(true)) : setOpenProvince(prev => !prev);
  const toggleCountry = () => openProvince ? (setOpenProvince(false), setOpenCountry(true)) : setOpenCountry(prev => !prev);

  return (
    <HorizontalLayout style={{ justifyContent: "flex-end", position: "relative" }} className={className}>
        <div>
            <MainButton toggle={toggleCountry} open={openCountry} img={country} />
            <DropdownRows open={openCountry} rows={countries} setChild={setCountry} toggleOpen={toggleCountry} setParent={setCountrys} defaultCountry={defaultCountry}/>
        </div>
        {country.code === "nl" && (<NlProvincesDropdown toggleProvince={toggleProvince} openProvince={openProvince} province={province} setProvince={setProvince} setCountrys={setCountrys} />)}
    </HorizontalLayout>
  );
}

const RotatingChevron = ({ open }) =>{
    return(
            <span
            style={{
              transition: "transform 0.3s ease",
              color: "var(--standard-text-color)",
              transform: open
                ? "rotate(180deg)"
                : "rotate(0deg)",
                marginRight: "0.2rem"
            }}
          >
            {icon("chevron-down", 16)}
          </span>
    )
}

const MainButton = ({ toggle, open, img }) => {
    return(
      <StandardButton
        onClick={toggle}
        className={`dropdown-toggle country-button ${open ? "active" : ""}`}
        backgroundColor = "white"
      >
        <RotatingChevron open={open} />
            <img src= {img.flag ? img.flag : `https://flagcdn.com/w20/${img.code}.png`}
 width="20" height="15" alt="flag" />
      </StandardButton>
    )
}

const NlProvincesDropdown = ({ toggleProvince, openProvince, province, setProvince, setCountrys }) => {
    return(
    <div>
        <MainButton toggle={toggleProvince} open={openProvince} img={province} />
        <DropdownRows open={openProvince} rows={NLPROVINCES} setChild={setProvince} toggleOpen={toggleProvince} setParent={(prov) => setCountrys({code: "nl", land: "Netherlands", province: prov.province})} />
    </div>

    )
}